/**
 * TUVI - Header Component
 * Sub-header debajo del topbar: titulo de seccion + boton hamburguesa (movil).
 * El usuario y el logout viven en el topbar.
 */

import React from 'react';
import './Header.css';

const Header = ({ title, subtitle, onToggleSidebar, sidebarOpen }) => {
  return (
    <header className="app-header">
      <div className="header-content">
        {/* Botón hamburguesa - solo visible en móvil */}
        <button
          className={`hamburger-btn ${sidebarOpen ? 'active' : ''}`}
          onClick={onToggleSidebar}
          aria-label="Abrir menú"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        <div className="header-title-section">
          <h1 className="header-title">{title || 'TUVI'}</h1>
          {subtitle && <p className="header-subtitle">{subtitle}</p>}
        </div>
      </div>
    </header>
  );
};

export default Header;
